import _ from 'lodash';
import React from 'react';
import { Center, Container, Grid, GridItem, Section } from '@fiverr-private/layout_components';
import {
    type ProCategoryData,
    RelatedLinks,
    CollapsibleFaqs,
    RelatedGuides,
    SupplementalContent,
} from '@fiverr-private/seo_content';
import { Image } from '@fiverr-private/media';
import { appTranslate } from '../../../../shared/utils/i18n';

interface ProfessionCategoryContentProps {
    seoData: ProCategoryData;
}

export const ProfessionCategoryContent: React.FC<ProfessionCategoryContentProps> = ({ seoData }) => {
    const { relatedLinks, faqs, relatedGuides, supplementalContent, localizedHeading } = seoData;

    const fiverrFreelancersAlt = appTranslate('search_perseus.seo_sub_category.fiverr_freelancers');

    return (
        <Section>
            {!_.isEmpty(supplementalContent) && (
                <Grid
                    templateColumns={{
                        default: '100%',
                        md: '50%_50%',
                    }}
                    marginBottom="12"
                >
                    <GridItem>
                        <SupplementalContent content={supplementalContent} />
                    </GridItem>

                    <GridItem>
                        <Center padding="0">
                            <Image
                                src="https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/7325c6fce78a1dc7afc991195449b21c-1768840732150/fiverr-freelancers.png"
                                alt={fiverrFreelancersAlt}
                                width="407px"
                            />
                        </Center>
                    </GridItem>
                </Grid>
            )}
            {!_.isEmpty(relatedLinks) && (
                <RelatedLinks
                    title={appTranslate('search_perseus.static_pages.related_links', {
                        params: {
                            subCategoryName: localizedHeading,
                        },
                    })}
                    relatedLinks={relatedLinks}
                />
            )}
            {!_.isEmpty(faqs) && (
                <Container>
                    <CollapsibleFaqs title={localizedHeading || 'FAQs'} faqs={faqs} />
                </Container>
            )}

            {!_.isEmpty(relatedGuides?.items) && <RelatedGuides guides={{ items: relatedGuides?.items || [] }} />}
        </Section>
    );
};
